var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectBgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#d0e0ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(163 130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2 -21C103 6.6 86.8 51.8 59.7 68.2C32.6 84.6 -5.3 72 -28.8 52C-52.3 32 -61.4 4.5 -54.2 -16.8C-47 -38.1 -23.5 -53.2 8.1 -55.8C39.7 -58.5 79.5 -48.6 91.2 -21Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6 -9.1C50 12.3 50.1 40.7 36.9 50.3C23.6 59.8 -3.1 50.4 -24.3 34.7C-45.6 19 -61.3 -3 -56.3 -19.7C-51.4 -36.3 -25.7 -47.7 -4.5 -46.2C16.6 -44.7 33.2 -30.5 41.6 -9.1Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(732 109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9 -10.9C48.4 6.6 43.8 30.3 27.1 44.1C10.3 57.9 -18.7 61.8 -37.1 48.9C-55.6 36.1 -63.4 6.5 -55.5 -13C-47.5 -32.4 -23.8 -41.6 -3 -40.6C17.7 -39.6 35.3 -28.4 41.9 -10.9Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(868 482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 -9.5C32.7 3.7 29 19.2 19.7 25.6C10.5 32 -4.3 29.2 -16.7 20.7C-29.1 12.3 -39 -1.8 -35.8 -13.6C-32.6 -25.4 -16.3 -34.8 -2.1 -34.2C12.1 -33.5 24.3 -22.7 28.5 -9.5Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2 -15.2C52.2 -0.1 40.9 20.3 23.6 33C6.4 45.7 -16.9 50.5 -32.8 40.1C-48.6 29.8 -57.1 4.3 -50.4 -13.2C-43.7 -30.7 -21.8 -40.1 -0.4 -40C21.1 -39.8 42.3 -30.2 47.2 -15.2Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 -15.8C68.6 5.2 58.5 35.9 36.1 52.9C13.7 70 -21 73.3 -43.1 57.7C-65.3 42 -74.8 7.3 -65.5 -15.3C-56.2 -38 -28.1 -48.5 -0.9 -48.2C26.2 -47.9 52.5 -36.7 60.5 -15.8Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(613 550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 -14.7C57.4 3.2 48 28.1 31.8 38.7C15.6 49.3 -7.4 45.5 -23.5 33.5C-39.7 21.5 -49.1 1.2 -44.1 -14.7C-39 -30.7 -19.5 -42.4 1.4 -42.9C22.3 -43.3 44.6 -32.5 51 -14.7Z",
    stroke: "#1d416c",
    fill: "none",
    strokeWidth: 20
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBgLight);
export default __webpack_public_path__ + "static/media/project_bg_light.8ba005aecf74e5ecd4480657d0537dcd.svg";
export { ForwardRef as ReactComponent };